import { Injectable } from '@angular/core';
import { HttpClient, HttpContext } from '@angular/common/http';
import { UrlService } from '../../../../../../environments/urlService';
import { Observable } from 'rxjs';
import { FairValueAndPpChartsOptionsService } from './charts-options-service/charts-options.service';
import { FmvChart, FmvChartsData, FmvChartsPreData, IrFmvChartsPreData } from '../pojo/fmv-charts-classes';
import { map } from 'rxjs/operators';
import { FmvFilterService } from './filter-service/fmv-filter.service';
import { PpChartsMenuValues } from '../pojo/fmv-charts-enums';
import { IS_SPINNER_ACTIVE } from "../../../../../util/interceptors";

@Injectable({
  providedIn: 'root',
})
export class FmvChartsService {
  private readonly url: string;

  constructor(
    private http: HttpClient,
    private urlService: UrlService,
  ) {
    this.url = this.urlService.getFmsUrl() + 'fmv-charts';
  }

  /**
   * Get chart data from backend and process it to generate chart options based on selected PPs.
   *
   * @param dto contain fund UUID and selected period and of ids of PPs, selected in summary-table
   * @param multiplicator update chart values after receiving data from backend based on selected investor's commitment
   * @returns Observable that emits FmvChart with processed data.
   */
  getIrFmvChartData(dto: IrFmvChartsPreData, multiplicator = 1): Observable<FmvChart> {
    return this.http.post<FmvChartsData>(this.url + '/ir', dto, {
      withCredentials: true,
      context: new HttpContext().set(IS_SPINNER_ACTIVE, false),
    }).pipe(
      map((chartsData: FmvChartsData) => {
        const chart = new FmvChart();
        chart.data = chartsData;
        chart.options.fmv = FairValueAndPpChartsOptionsService
          .fillChartOptionsForType(chartsData.fmv, PpChartsMenuValues.fmv, multiplicator);
        return chart;
      }),
    );
  }

  /**
   * Get chart data from backend and process it to generate chart options and extremum values.
   *
   * @param dto List of FmvChartsPreData containing fund UUIDs and periods.
   * @returns Observable that emits FmvChart with processed data.
   */
  getFmvChartData(dto: FmvChartsPreData[]): Observable<FmvChart> {
    return this.http.post<FmvChartsData>(this.url, dto, { withCredentials: true }).pipe(
      map((chartsData: FmvChartsData) => {
        const chart = new FmvChart();
        chart.data = chartsData;
        chart.extremum = FmvFilterService.getInitialMinMaxValues(chartsData);
        chart.options.fmv = FairValueAndPpChartsOptionsService
          .fillChartOptionsForType(chartsData.fmv, PpChartsMenuValues.fmv);
        chart.options.investment = FairValueAndPpChartsOptionsService
          .fillChartOptionsForType(chartsData.investment, PpChartsMenuValues.investment);
        return chart;
      }),
    );
  }


}
